
import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Input, Radio, Divider } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFlightOffers } from '../../../redux/flight/flightOffersSlice';
import { FaTimes } from 'react-icons/fa';

const FlightOffers = forwardRef(({
  totalPriceBaggages,
  appliedCheckLogin,
  setAppliedCheckLogin,
  applyDiscount,
  applyDiscountShow,
  setApplyDiscountShow,
  isCongratulations,
  setIsCongratulations,
  isValidCoupon,
  setValidCoupon,
  totalAfterDiscount,
  setErrorMessage,
  errorMessage,
  setDiscountAmountOffer
}, ref) => {

  const dispatch = useDispatch();
  const { offers, loading, error } = useSelector((state) => state.flightOffers);

  useEffect(() => {
    dispatch(fetchFlightOffers());
  }, [dispatch]);

  const [selectedCode, setSelectedCode] = useState("");

  const handleInputChange = (e) => {
    setSelectedCode(e.target.value);
  };


  const handleRemoveCode = () => {
    setSelectedCode("");
    setAppliedCheckLogin(null);
    setApplyDiscountShow(false);
    setIsCongratulations(false);
    setValidCoupon(null);
    setErrorMessage("");
    setDiscountAmountOffer(0);
  };

  useImperativeHandle(ref, () => ({
    handleRemoveCode
  }));

  let getUser = JSON.parse(localStorage.getItem("user"));
  let getTokenId = JSON.parse(localStorage.getItem("tokenId"));
  let totalAmount = totalAfterDiscount;

  useEffect(() => {
    if (!appliedCheckLogin) return;
    if (appliedCheckLogin?.is_login === 1 && !getTokenId) {
      dispatch(setModal2Open(true));
    } else if (appliedCheckLogin?.is_login === 1 && getTokenId) {
      applyDiscount();
    } else if (!appliedCheckLogin?.is_login) {
      applyDiscount();
    }
  }, [appliedCheckLogin]);

  useEffect(() => {
    if (selectedCode) {
      const offer = offers.find((offer) => offer.code === selectedCode);
      if (offer) {
        handleRadioChange(selectedCode, offer);
      }
    }
  }, [totalAmount, selectedCode]);

  const handleRadioChange = (code, offer) => {
    setAppliedCheckLogin(offer);
    setSelectedCode(code);
    setApplyDiscountShow(true);
    setIsCongratulations(true);
    setValidCoupon(null);
    setErrorMessage("");
  };

  // const handleRadioChange = (code, offer) => {
  //   const minOrderValue = parseFloat(offer.min_order_value);
  //   const maxOrderValue = parseFloat(offer.max_order_value);
  //   setSelectedCode(code);
  //   if (totalAmount >= minOrderValue && totalAmount <= maxOrderValue) {
  //     setAppliedCheckLogin(offer);
  //     setApplyDiscountShow(true);
  //     setIsCongratulations(true);
  //     setValidCoupon(null);
  //     setErrorMessage("");
  //   } else {
  //     setValidCoupon(null);
  //     setIsCongratulations(false);
  //     setDiscountAmountOffer(0);
  //     setApplyDiscountShow(false);
  //     setErrorMessage("Coupon cannot be applied.");
  //   }
  // };

  const filteredOffers = offers
    .filter(offer =>
      totalPriceBaggages >= parseFloat(offer.min_order_value) &&
      totalPriceBaggages <= parseFloat(offer.max_order_value)
    )
    .sort((a, b) => parseFloat(a.min_order_value) - parseFloat(b.min_order_value));

  return (
    <>
      <div className="card mb-md-5 mb-2">
        <div className="card-header py-2">
          <h3>Apply Discount</h3>
          <p className="fw-bold">
            <small>Have a discount/ promo code to redeem  </small>
          </p>
        </div>

        <div className="card-body py-2">
          <div className="d-flex gap-10 mt-1 mb-4">
            <Input
              type="text"
              value={selectedCode}
              onChange={handleInputChange}
              placeholder="Promo Code"
              className="form-control rounded"
              style={{ height: "40px", padding: "10px", outline: "none" }}
              suffix={
                selectedCode && <FaTimes onClick={handleRemoveCode} />
              }
            />

            {/* {!applyDiscountShow ? (
                 isDisabled && (
                   <a
                     className="btn btn-primary menu-block rounded text-center"
                     onClick={handleApplyClick}
                   >
                     Apply
                   </a>
                 )
               ) : (
                 <a
                   className="btn btn-primary menu-block rounded text-center"
                   onClick={handleRemoveCode}
                 >
                   Remove
                 </a>
               )} */}

            {applyDiscountShow && (
              <a
                className="btn btn-primary menu-block rounded text-center"
                onClick={handleRemoveCode}
              >
                Remove
              </a>
            )}
          </div>
          {isCongratulations && (
            <p className="text_grn mb-2">
              Congratulations coupon code has been applied successfull{" "}
              {appliedCheckLogin?.description}
            </p>
          )}
          {isValidCoupon && (
            <p className="text_red mb-2" style={{ color: "red" }}>
              {isValidCoupon}
            </p>
          )}

          {errorMessage && (
            <p className="text_red mb-2" style={{ color: "red" }}>
              {errorMessage}
            </p>
          )}

          {/* {isCongratulations ? (
               <p className="text_grn mb-2">
                 Congratulations! Coupon code has been applied successfully:{" "}
                 {appliedCheckLogin?.description}
               </p>
             ) : selectedCode ? ( // Show only if a code is entered
               <p className="text_red mb-2" style={{ color: "red" }}>
                 Sorry, this coupon code is not valid.
               </p>
             ) : null} */}

          <div>
            {filteredOffers?.map((offer, index) => (
              <div key={index}>
                <label className="d-flex align-items-center gap-10">
                  <span>
                    <Radio
                      id={offer?.code}
                      name="offerradio"
                      checked={selectedCode === offer?.code}
                      onChange={() => handleRadioChange(offer?.code, offer)}
                    />
                  </span>
                  <div>
                    <p>
                      <b>{offer.code}</b>
                    </p>
                    <p className="lh-14">
                      <small className="fw-bold">{offer?.description}</small>
                    </p>
                  </div>
                </label>
                {index < offers?.length - 1 && <Divider className="my-3" />}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
});

export default FlightOffers;
